<template>
  <base-row
    v-bind="$props"
    :selectable="false"
    class="cursor-pointer transition-all duration-1000"
    :class="{
      'bg-red-200': hasError,
      'bg-green-200': showSuccess
    }"
    @click="triggerSelected()"
  >
    <td class="w-10/12 !whitespace-normal">
      <div class="text-blue-600">
        <b>{{ item.package.details.product_name }}</b>
      </div>
      <div class="flex flex-col lg:flex-row flex-wrap pt-1 text-xxs lg:text-xs text-gray-700 gap-x-3 gap-y-1">
        <span>
          <strong>Tag: </strong>
          <span>{{ item.package.details.tag_num || '-' }}</span>
        </span>
        <span>
          <strong>Lot: </strong>
          <span>{{ item.package.details.lot_num || '-' }}</span>
        </span>
        <span v-if="item.space">
          <strong>Space: </strong>
          <span>{{ item.space.name || '-' }}</span>
        </span>
        <span v-if="countMethod === 'sub_lot'">
          <strong>Sub-Lot: </strong>
          <span>{{ item.package.sub_lot_num || '-' }}</span>
        </span>
      </div>
    </td>
    <td class="text-right">
      {{ item.counted_amount }}
    </td>
    <td class="text-right">
      {{ showExpectedAmount ? item.expected_amount : '--' }}
    </td>
  </base-row>
</template>

<style>
.\!whitespace-normal {
  white-space: normal !important;
}
</style>

<script>
import { Link } from '@inertiajs/vue3'
import TableRow from '@/Components/Table/TableRow'
import RowProps from '@/Components/Table/Mixins/RowProps'
import BasicBadge from '@/Components/Badges/BasicBadge.vue'
import _date from '@/Filters/Date'
import _dollars from '@/Filters/Dollars'
import _time from '@/Filters/Time'
import moment from 'moment'

export default {
  components: {
    'base-row': TableRow,
    Link,
    BasicBadge
  },

  mixins: [RowProps],

  props: {
    /**
     * A function that we can use to generate the URL to view a item. Returns a string that is a valid URL
     */
    showRoute: {
      type: Function,
      default: (item) => null
    },
    defaultLocationName: {
      type: String,
      default: 'Default Store'
    },
    hasError: {
      type: Boolean,
      default: false
    },
    showExpectedAmount: {
      type: Boolean,
      default: false
    },
    countMethod: {
      type: String,
      required: true
    }
  },

  data: () => ({
    showSuccess: false
  }),

  computed: {
    /**
     * Returns the URL we can use to view a customer
     */
    editTransferRoute() {
      return this.showRoute(this.item)
    },
    /**
     * Returns true if this customer has a valid URL to view a customer
     * @returns {boolean}
     */
    hasRoute() {
      return this.editTransferRoute !== null
    },
    statusDate() {
      if (this.item.display_status === 'Received') {
        return this.item.received_at
      }

      if (this.item.display_status === 'In Transit') {
        return this.item.sent_at
      }

      return null
    }
  },
  methods: {
    _date,
    _dollars,
    _time,
    formatDate(value) {
      return moment(String(value)).format('MM/DD/YYYY')
    },
    successAnimation() {
      if (this.showSuccess) return

      this.showSuccess = true
      setTimeout(() => {
        this.showSuccess = false
      }, 1000)
    },
    triggerSelected() {
      this.$emit('selected', {
        item: this.item,
        successAnimation: this.successAnimation
      })
    }
  }
}
</script>
